<template>
  <transition-group
    name="toast-fade"
    tag="div"
    class="left-0 my-0 mx-auto max-w-[25rem] overflow-hidden absolute right-0 text-center top-4 z-[9999]"
  >
    <otello-snackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :action="snackMessage.action"
    />
  </transition-group>
</template>

<script>
import OtelloSnackbar from './Snackbar.vue';
import alertMixin from 'shared/mixins/alertMixin';
import timerLifecycleMixin from 'dashboard/mixins/timerLifecycleMixin';

export default {
  components: {
    OtelloSnackbar,
  },
  mixins: [alertMixin, timerLifecycleMixin],
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    this.$emitter.on('newToastMessage', this.onNewToastMessage);
  },
  beforeUnmount() {
    this.$emitter.off('newToastMessage', this.onNewToastMessage);
    this.clearScheduledTimers();
  },
  methods: {
    onNewToastMessage(message, action) {
      this.snackMessages.push({
        key: new Date().getTime(),
        message,
        action,
      });
      this.scheduleTimer(() => {
        this.snackMessages.splice(0, 1);
      }, this.duration);
    },
  },
};
</script>
